import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { Button, TabPane, TabContent, Row, Col, ListGroup, ListGroupItem, ButtonGroup, InputGroup, Input, InputGroupAddon, FormGroup, Label, Collapse } from 'reactstrap';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import { IoLogoApple } from 'react-icons/io';
import Assets from '../../../services/Assets';
import PSO from '../../../services/PSO';
import { useAuth } from '../../../Context/Auth/AuthContext';
import Select from 'react-select';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import ModalAppleMusicAlert from '../../../Layout/Components/ModalAppleMusicAlert';

const schema = Yup.object().shape({
  osso: Yup.string().required(Strings('song_name_is_required')),
  osba: Yup.string().required(Strings('band_name_is_required'))
});

export default function VideoSong (props) {
  const { parentSong, parentSetSong, parentSetSongType, parentSongType, parentSelectCallback, showSaveButton, saveButtonCallback, disableOriginalSong, audioPreviewRef, audioSelectedRef, createMode } = props;

  const { toggleLoading, authenticated } = useAuth();

  const { register, errors, handleSubmit } = useForm({
    validationSchema: schema,
  });

  const [pepblastSongs, setPepblastSongs] = useState();
  const [originalPepblastSongs, setOriginalPepblastSongs] = useState();
  const [appleMusicSongs, setAppleMusicSongs] = useState();

  const [currentPlaySong, setCurrentPlaySong] = useState();

  const [categoriesStyle, setCategoriesStyle] = useState();
  const [categoriesStyleOptions, setCategoriesStyleOptions] = useState();
  const [categoriesCurrentOption, setCategoriesCurrentOption] = useState();

  const [genres, setGenres] = useState();
  const [genresOptions, setGenresOptions] = useState();
  const [genresCurrentOption, setGenresCurrentOption] = useState();

  const [appleMusicSearchString, setAppleMusicSearchString] = useState('');

  const [ospau, setOspau] = useState(0);
  const [showOriginalSongForm, setShowOriginalSongForm] = useState(true);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const [osAccordion, setOsAccordion] = useState(false);
  const toggleOsAccordion = useCallback(() => {
    setOsAccordion(!osAccordion);
  }, [setOsAccordion, osAccordion]);
  
  const [osMusicLinks, setOsMusicLinks] = useState(false);
  const toggleOsMusicLinks = useCallback(() => {
    setOsMusicLinks(!osMusicLinks);
  }, [setOsMusicLinks, osMusicLinks]);

  const [modalAlertAppleMusic, setModalAlertAppleMusic] = useState(false);
  const toggleModalAlertAppleMusic = useCallback(() => {
    setModalAlertAppleMusic(!modalAlertAppleMusic);
  }, [setModalAlertAppleMusic, modalAlertAppleMusic]);

  const buildCategoriesStyleOptions = useCallback((resp) => {
    if (resp && resp.its && resp.its.length > 0) {
      const options = [];

      options.push({
        value: '',
        label: 'ALL'
      });

      resp.its.map((value) => {
        if (parseInt(value.id) !== 3) {
          options.push({
            value: value.id,
            label: value.la
          });
        }
        return true;
      });

      setCategoriesStyleOptions(options);
      setCategoriesCurrentOption(options[0]);
    }
  }, [setCategoriesStyleOptions, setCategoriesCurrentOption]);

  const buildGenresOptions = useCallback((resp) => {
    if (resp && resp.length > 0) {
      const options = [];

      options.push({
        value: '',
        label: 'ALL'
      });

      resp.map((value) => {
        if (parseInt(value.ID) !== 0) {
          options.push({
            value: value.ID,
            label: value.Name
          });
        }
        return true;
      });

      setGenresOptions(options);
      setGenresCurrentOption(options[0]);
    }
  }, [setGenresOptions, setGenresCurrentOption]);

  const showAllPepblastSongs = useCallback(() => {
    setPepblastSongs(originalPepblastSongs);
  }, [setPepblastSongs, originalPepblastSongs]);

  const applyPepblastSongFilter = useCallback((type, targetOption) => {
    if (type && targetOption) {
      const allPepblastIts = originalPepblastSongs.its;
      const filteredSongsIts = [];

      let id;
      if (targetOption[0] && targetOption[0].ID) {
        id = targetOption[0].ID;
      } else if (targetOption[0] && targetOption[0].id) {
        id = targetOption[0].id;
      }

      if (type === 1) {
        // Filter by style
        allPepblastIts.forEach((item) => {
          if (item.ci && item.ci.includes(id)) {
            filteredSongsIts.push(item);
          }
        });
      } else if (type === 2) {
        // Filter by genre
        allPepblastIts.forEach((item) => {
          if (parseInt(item.ty) === parseInt(id)) {
            filteredSongsIts.push(item);
          }
        });
      }

      setPepblastSongs({...originalPepblastSongs, its: filteredSongsIts});
    }
  }, [originalPepblastSongs, setPepblastSongs]);

  const filterByStyle = useCallback((option) => {
    setCategoriesCurrentOption(option);
    setGenresCurrentOption(genresOptions[0]);

    let doFilter = false;
    let showAll = false;
    let targetOption;

    if (option && option.value === '') {
      showAll = true;
    } else if (categoriesStyle && categoriesStyle.its && categoriesStyle.its.length > 0) {
      targetOption = categoriesStyle.its.filter((value) => {
        if (option.value === value.id) {
          doFilter = true;
          return value;
        }
        return false;
      });
    }

    if (showAll) {
      showAllPepblastSongs();
    } else if (doFilter && targetOption) {
      applyPepblastSongFilter(1, targetOption);
    }
  }, [categoriesStyle, setGenresCurrentOption, genresOptions, showAllPepblastSongs, applyPepblastSongFilter]);

  const filterByGenre = useCallback((option) => {
    setGenresCurrentOption(option);
    setCategoriesCurrentOption(categoriesStyleOptions[0]);

    let doFilter = false;
    let showAll = false;
    let targetOption;

    if (option && option.value === '') {
      showAll = true;
    } else if (genres && genres.length > 0) {
      targetOption = genres.filter((value) => {
        if (option.value === value.ID) {
          doFilter = true;
          return value;
        }
        return false;
      });
    }

    if (showAll) {
      showAllPepblastSongs();
    } else if (doFilter && targetOption) {
      applyPepblastSongFilter(2, targetOption);
    }
  }, [genres, setCategoriesCurrentOption, categoriesStyleOptions, showAllPepblastSongs, applyPepblastSongFilter]);

  const [activeTab, setActiveTab] = useState('1');
  const toggle = useCallback((tab) => {
    setActiveTab(tab);
  }, [setActiveTab]);

  const pauseAudioPreviewRef = useCallback(() => {
    // Checking and pausing preview audio
    if (audioPreviewRef && audioPreviewRef.current) {
      if (!audioPreviewRef.current.paused) {
        audioPreviewRef.current.pause();
      }
    }
  }, [audioPreviewRef]);

  const pauseAudioSelectedRef = useCallback(() => {
    // Checking and pausing selected audio
    if (audioSelectedRef && audioSelectedRef.current) {
      if (!audioSelectedRef.current.paused) {
        audioSelectedRef.current.pause();
      }
    }
  }, [audioSelectedRef]);

  const removeSelectedSong = useCallback(() => {
    if (parentSetSong) {
      parentSetSong();
    }
    if (parentSetSongType) {
      parentSetSongType();
    }
    pauseAudioSelectedRef();
  }, [parentSetSong, parentSetSongType, pauseAudioSelectedRef]);

  const selectSong = useCallback((obj, type) => {
    const objToSet = {};
    objToSet.obj = obj;
    objToSet.type = type;

    let valid = false;

    if (type === 1) {
      objToSet.name = obj.na;
      objToSet.artist = obj.ba;
      objToSet.thumb = `${pepblastSongs.stu}/${obj.tl}`;
      objToSet.preview = `${pepblastSongs.ssu}/${obj.sl}`;
      valid = true;
    } else if (type === 2){
      if (obj && obj.attributes && obj.attributes.name) {
        objToSet.name = obj.attributes.name;
      }
      if (obj && obj.attributes && obj.attributes.artistName) {
        objToSet.artist = obj.attributes.artistName;
      }
      if (obj && obj.attributes && obj.attributes.artwork && obj.attributes.artwork.url) {
        objToSet.thumb = obj.attributes.artwork.url.replace('{w}', obj.attributes.artwork.width).replace('{h}', obj.attributes.artwork.height);
      }
      if (obj && obj.attributes && obj.attributes.previews && obj.attributes.previews[0]) {
        objToSet.preview = obj.attributes.previews[0].url;
      }
      valid = true;

      toggleModalAlertAppleMusic();
    } else if (type === 3) {
      objToSet.name = obj.osso;
      objToSet.artist = obj.osba;
      valid = true;
    }

    if (valid) {
      if (parentSetSong) {
        parentSetSong(objToSet);
      }
      if (parentSetSongType) {
        parentSetSongType(type);
      }

      if (audioSelectedRef && audioSelectedRef.current) {
        const audio = audioSelectedRef.current;
        if (!audio.paused) {
          audio.pause();
        }
  
        audio.src = objToSet.preview;

        audio.onplay = () => {
          pauseAudioPreviewRef();
        }
      }

      if (parentSelectCallback) {
        parentSelectCallback();
      }
    }

    if (createMode) {
      scrollTop();
    }
  }, [pepblastSongs, parentSetSong, parentSetSongType, parentSelectCallback, pauseAudioPreviewRef, audioSelectedRef, toggleModalAlertAppleMusic, createMode]);

  const playSong = useCallback((obj, type) => {
    const objToSet = {};
    objToSet.obj = obj;
    objToSet.type = type;

    let valid = false;

    if (type === 1) {
      objToSet.name = obj.na;
      objToSet.artist = obj.ba;
      objToSet.thumb = `${pepblastSongs.stu}/${obj.tl}`;
      objToSet.preview = `${pepblastSongs.ssu}/${obj.sl}`;
      valid = true;
    } else if (type === 2) {
      if (obj && obj.attributes && obj.attributes.name) {
        objToSet.name = obj.attributes.name;
      }
      if (obj && obj.attributes && obj.attributes.artistName) {
        objToSet.artist = obj.attributes.artistName;
      }
      if (obj && obj.attributes && obj.attributes.artwork && obj.attributes.artwork.url) {
        objToSet.thumb = obj.attributes.artwork.url.replace('{w}', obj.attributes.artwork.width).replace('{h}', obj.attributes.artwork.height);
      }
      if (obj && obj.attributes && obj.attributes.previews && obj.attributes.previews[0]) {
        objToSet.preview = obj.attributes.previews[0].url;
      }
      valid = true;
    }

    if (valid) {
      setCurrentPlaySong(objToSet);

      if (audioPreviewRef && audioPreviewRef.current) {
        const audio = audioPreviewRef.current;
        if (!audio.paused) {
          audio.pause();
        }
  
        audio.src = objToSet.preview;
        audio.play();

        audio.onplay = () => {
          pauseAudioSelectedRef();
        }
      }
    }
  }, [setCurrentPlaySong, pepblastSongs, pauseAudioSelectedRef, audioPreviewRef]);

  const removePlaySong = useCallback(() => {
    setCurrentPlaySong();
    if (audioPreviewRef && audioPreviewRef.current) {
      const audio = audioPreviewRef.current;
      if (!audio.paused) {
        audio.pause();
      }
    }
  }, [setCurrentPlaySong, audioPreviewRef]);

  const orderPepblastSongByRa = (songs) => {
    if (songs) {
      songs.sort((a, b) => {
        if (a.ra > b.ra) return -1;
        if (a.ra < b.ra) return 1;
        return 0;
      });
      return songs;
    }
    return false;
  }

  const getPepblastSongs = useCallback(async () => {
    toggleLoading(true);
    let resp;
    try {
      resp = await Assets.getSongList();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_songs')} [ID==04]`);
    }

    if (resp && resp.its) {
      resp.its = orderPepblastSongByRa(resp.its);
      
      // Setting to use always HTTPs
      if (resp.sbu) {
        resp.sbu = resp.sbu.replace(/https?:\/\//, 'https://');
      }
      if (resp.sfu) {
        resp.sfu = resp.sfu.replace(/https?:\/\//, 'https://');
      }
      if (resp.siu) {
        resp.siu = resp.siu.replace(/https?:\/\//, 'https://');
      }
      if (resp.ssu) {
        resp.ssu = resp.ssu.replace(/https?:\/\//, 'https://');
      }
      if (resp.stu) {
        resp.stu = resp.stu.replace(/https?:\/\//, 'https://');
      }

      setPepblastSongs(resp);
      setOriginalPepblastSongs(resp);
    }

    toggleLoading(false);
  }, [toggleLoading, setPepblastSongs, setOriginalPepblastSongs]);

  const getCategoriesStyle = useCallback(async () => {
    toggleLoading(true);
    let resp;
    try {
      resp = await Assets.getCategories();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_style')} [ID==04]`);
    }

    if (resp) {
      setCategoriesStyle(resp);
      buildCategoriesStyleOptions(resp);
    }

    toggleLoading(false);
  }, [toggleLoading, setCategoriesStyle, buildCategoriesStyleOptions]);

  const getGenres = useCallback(async () => {
    toggleLoading(true);
    let resp;
    try {
      resp = await Assets.getGenresList();
    } catch (err) {
      toast.error(`${Strings('error_while_getting_genres')} [ID==04]`);
    }

    if (resp) {
      setGenres(resp);
      buildGenresOptions(resp);
    }

    toggleLoading(false);
  }, [toggleLoading, setGenres, buildGenresOptions]);

  const getAppleMusicTopSongs = useCallback(async () => {
    try {
      const songs = await PSO.getAppleMusicTopMusics();

      if (songs && songs.length > 0) {
        setAppleMusicSongs(songs);
      }
    } catch (err) {
      console.error(`${Strings('error_while_getting_apple_music_songs')} [ID==04]`);
    }
  }, [setAppleMusicSongs]);

  const searchAppleMusicSongs = useCallback(async () => {
    if (appleMusicSearchString && appleMusicSearchString !== null && appleMusicSearchString !== '' && appleMusicSearchString !== ' ') {
      toggleLoading(true);
      try {
        const songs = await PSO.searchAppleMusic(appleMusicSearchString);
        if (songs && songs.length > 0) {
          setAppleMusicSongs(songs);
        }
      } catch (err) {
        console.error(`${Strings('error_while_getting_apple_music_songs')} [ID==04]`);
      } finally {
        toggleLoading(false);
      }
    } else {
      toggleLoading(true);
      await getAppleMusicTopSongs();
      toggleLoading(false);
    }
  }, [appleMusicSearchString, setAppleMusicSongs, toggleLoading, getAppleMusicTopSongs]);

  useEffect(() => {
    getPepblastSongs();
    getCategoriesStyle();
    getGenres();
    getAppleMusicTopSongs();
  }, [getPepblastSongs, getCategoriesStyle, getGenres, getAppleMusicTopSongs]);

  const submitOriginalSong = useCallback(async (data) => {
    let valid = true;
    if (data.osge === '0' || data.osge === 0) {
      valid = false;
      toast.error(Strings('song_genre_is_required'));
    }
    if (data.osfile.length === 0) {
      valid = false;
      toast.error(Strings('song_file_is_required'));
    }

    if (valid) {
      const args = {
        osba: data.osba,
        osso: data.osso,
        osge: data.osge,
        ospau: ospau,
        un: authenticated.un,
        al: authenticated.al
      };

      // Optional fields
      if (data.oswe) {
        args.oswe = data.oswe;
      }
      if (data.ospe) {
        args.ospe = data.ospe;
      }
      if (data.osemail) {
        args.osemail = data.osemail;
      }
      if (data.ostel) {
        args.ostel = data.ostel;
      }

      // Music links
      if (data.oslapple) {
        args.oslapple = data.oslapple;
      }
      if (data.oslspotify) {
        args.oslspotify = data.oslspotify;
      }
      if (data.oslyoutube) {
        args.oslyoutube = data.oslyoutube;
      }
      if (data.oslyoutubemusic) {
        args.oslyoutubemusic = data.oslyoutubemusic;
      }
      if (data.oslamazon) {
        args.oslamazon = data.oslamazon;
      }
      if (data.oslsoundcloud) {
        args.oslsoundcloud = data.oslsoundcloud;
      }
      if (data.osldeezer) {
        args.osldeezer = data.osldeezer;
      }
      if (data.osltidal) {
        args.osltidal = data.osltidal;
      }
      if (data.oslcustom) {
        args.oslcustom = data.oslcustom;
      }

      const songFile = data.osfile[0];

      toggleLoading(true);
      try {
        const response = await PSO.uploadUserSong(args, songFile);

        if (response && response.result === 'success') {
          const obj = {
            element_id: response.element_id,
            osba: data.osba,
            osso: data.osso
          };

          selectSong(obj, 3);
          setShowOriginalSongForm(false);
        } else {
          let errorText = Strings('error_on_uploading_original_song');
          if (response && response.errorText) {
            errorText = response.errorText;
          }
          toast.error(errorText);
        }
      } catch (err) {
        toast.error(Strings('error_on_uploading_original_song'));
      } finally {
        toggleLoading(false);
      }
    }
  }, [setShowOriginalSongForm, authenticated, ospau, toggleLoading, selectSong]);

  useEffect(() => {
    if (parentSong) {
      const objToSet = parentSong;

      if (audioSelectedRef && audioSelectedRef.current) {
        const audio = audioSelectedRef.current;
        if (!audio.paused) {
          audio.pause();
        }
  
        audio.src = objToSet.preview;
  
        audio.onplay = () => {
          pauseAudioPreviewRef();
        }
      }
    }
  }, [parentSong, pauseAudioPreviewRef, audioSelectedRef]);

  return (
    <Fragment>

      <Row className={!parentSong ? `d-none` : ``}>
        <Col>
          <ListGroup className='mb-5 song-card'>
            <ListGroupItem>
              <div className='widget-content p-0'>
                <div className='widget-content-wrapper'>
                  <div className='widget-content-left mr-3'>
                    {parentSongType && parentSongType !== 3 && (
                      <img
                        width={140}
                        className='rounded'
                        alt={parentSong && parentSong.name}
                        src={parentSong && parentSong.thumb}
                      />
                    )}
                  </div>
                  <div className='widget-content-left'>
                    <div className='widget-heading'>
                      <div>
                        <div className='badge badge-success mr-2'>{Strings('selected_song')}</div>
                        {parentSongType === 1 && <div className='badge badge-primary'>{Strings('pepblast_song')}</div>}
                        {parentSongType === 2 && <div className='badge badge-primary'>{Strings('apple_music')}</div>}
                      </div>
                      {parentSong && parentSong.name}
                    </div>
                    <div className='widget-subheading artist'>
                      {parentSong && parentSong.artist}
                    </div>
                    {parentSongType && parentSongType !== 3 && (
                      <div className='mt-2'>
                        <audio
                          controls
                          controlsList='nodownload'
                          ref={audioSelectedRef}
                        >
                          <source type='audio/mp3' />
                          {Strings('your_browser_does_not_support_html5')}
                        </audio>
                      </div>
                    )}
                  </div>
                  <div className='widget-content-right'>
                    <ButtonGroup>
                      <Button
                        color='danger'
                        outline
                        size='sm'
                        onClick={removeSelectedSong}
                      >
                        {Strings('unselect')}
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </ListGroupItem>
            {showSaveButton && saveButtonCallback && (
              <ListGroupItem>
                <div className='text-right'>
                  <Button
                    color='primary'
                    onClick={saveButtonCallback}
                  >
                    {Strings('update_song')}
                  </Button>
                </div>
              </ListGroupItem>
            )}
          </ListGroup>
        </Col>
      </Row>

      <Row className={!currentPlaySong ? `d-none` : ``}>
        <Col>
          <ListGroup className='mb-5'>
            <ListGroupItem>
              <div className='widget-content p-0'>
                <div className='widget-content-wrapper'>
                  <div className='widget-content-left mr-3'>
                    <img
                      width={140}
                      className='rounded'
                      alt={currentPlaySong && currentPlaySong.name}
                      src={currentPlaySong && currentPlaySong.thumb}
                    />
                  </div>
                  <div className='widget-content-left'>
                    <div className='widget-heading'>
                      <div>
                        <div className='badge badge-secondary mr-2'>{Strings('playing_now')}</div>
                        {currentPlaySong && currentPlaySong.type && currentPlaySong.type === 1 && <div className='badge badge-secondary'>{Strings('pepblast_song')}</div>}
                        {currentPlaySong && currentPlaySong.type && currentPlaySong.type === 2 && <div className='badge badge-secondary'>{Strings('apple_music')}</div>}
                      </div>
                      {currentPlaySong && currentPlaySong.name}
                    </div>
                    <div className='widget-subheading artist'>
                      {currentPlaySong && currentPlaySong.artist}
                    </div>
                    <div className='mt-2'>
                      <audio
                        controls
                        controlsList='nodownload'
                        ref={audioPreviewRef}
                      >
                        <source
                          type='audio/mp3'
                        />
                        {Strings('your_browser_does_not_support_html5')}
                      </audio>
                    </div>
                  </div>
                  <div className='widget-content-right'>
                    <ButtonGroup>
                      <Button
                        color='success'
                        outline
                        size='sm'
                        onClick={() => selectSong(currentPlaySong.obj, currentPlaySong.type)}
                      >
                        {Strings('select')}
                      </Button>
                      <Button
                        color='danger'
                        outline
                        size='sm'
                        onClick={removePlaySong}
                      >
                        {Strings('close')}
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </ListGroupItem>
          </ListGroup>
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            className={'border-0 btn-wide btn-transition ' + classnames({ active: activeTab === '1' })}
            outline
            color='primary'
            onClick={() => toggle('1')}
          >
            {Strings('pepblast_song')}
          </Button>
          <Button
            className={'border-0 btn-wide btn-transition mr-1 ml-1 ' + classnames({ active: activeTab === '2' })}
            outline
            color='primary'
            onClick={() => toggle('2')}
          >
            <div className='d-flex'>
              <div className='apple-song-icon-container mr-1'>
                <IoLogoApple fontSize='22px' />
              </div>
              <div>
                {Strings('apple_music')}
              </div>
            </div>
          </Button>
          {disableOriginalSong !== true && (
            <Button
              className={'border-0 btn-wide btn-transition ' + classnames({ active: activeTab === '3' })}
              outline
              color='primary'
              onClick={() => toggle('3')}
            >
              {Strings('original_song')}
            </Button>
          )}
        </Col>
      </Row>

      <Row className='mt-3'>
        <Col>
          <TabContent activeTab={activeTab}>
            <TabPane tabId='1'>

              <Row className='mb-3'>
                <Col md={4}>
                  <small>{Strings('filter_by_style')}</small>
                  <Select
                    value={categoriesCurrentOption}
                    options={categoriesStyleOptions}
                    onChange={filterByStyle}
                  />
                </Col>
                <Col md={4}>
                  <small>{Strings('filter_by_genre')}</small>
                  <Select
                    value={genresCurrentOption}
                    options={genresOptions}
                    onChange={filterByGenre}
                  />
                </Col>
              </Row>

              <ListGroup>
                {pepblastSongs && pepblastSongs.its && pepblastSongs.its.length > 0 && pepblastSongs.its.map((value, index) => (
                  <Fragment key={`${value.id}_${value.ba}_${index}`}>
                    {index < 50 && (
                      <ListGroupItem key={`${value.id}_${value.ba}_${index}`}>
                        <div className='widget-content p-0'>
                          <div className='widget-content-wrapper'>
                            <div className='widget-content-left mr-3'>
                              <img
                                width={42}
                                className='rounded'
                                src={`${pepblastSongs.stu}/${value.tl}`}
                                alt={`${value.na} = ${value.ba}`}
                              />
                            </div>
                            <div className='widget-content-left'>
                              <div className='widget-heading'>
                                {value.na}
                              </div>
                              <div className='widget-subheading artist'>
                                {value.ba}
                              </div>
                            </div>
                            <div className='widget-content-right'>
                              <ButtonGroup size='md'>
                                <Button
                                  color='secondary'
                                  onClick={() => playSong(value, 1)}
                                  className='play-song-btn'
                                >
                                  <i className='pe-7s-play'> </i>
                                </Button>
                                <Button
                                  color='secondary'
                                  onClick={() => selectSong(value, 1)}
                                >
                                  {Strings('select')}
                                </Button>
                              </ButtonGroup>
                            </div>
                          </div>
                        </div>
                      </ListGroupItem>
                    )}
                  </Fragment>
                ))}
              </ListGroup>

            </TabPane>

            <TabPane tabId='2'>
              <Row className='mb-2'>
                <Col md={12}>
                  <small>{Strings('non_apple_music_obs')}</small>
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={6}>
                  <InputGroup>
                    <Input
                      placeholder={Strings('search_on_apple_music')}
                      bsSize='sm'
                      onChange={(evt) => setAppleMusicSearchString(evt.target.value)}
                    />
                    <InputGroupAddon addonType="append">
                      <Button
                        color="secondary"
                        size='sm'
                        onClick={searchAppleMusicSongs}
                      >
                        {Strings('search')}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              
              <ListGroup>
                {appleMusicSongs && appleMusicSongs.length > 0 && appleMusicSongs.map((value) => (
                  <ListGroupItem key={value.id}>
                    <div className='widget-content p-0'>
                      <div className='widget-content-wrapper'>
                        <div className='widget-content-left mr-3'>
                          <img
                            width={42}
                            className='rounded'
                            src={value.attributes.artwork.url.replace('{w}', value.attributes.artwork.width).replace('{h}', value.attributes.artwork.height)}
                            alt={`${value.attributes.name} = ${value.attributes.artistName}`}
                          />
                        </div>
                        <div className='widget-content-left'>
                          <div className='widget-heading'>
                            {value.attributes.name}
                          </div>
                          <div className='widget-subheading artist'>
                            {value.attributes.artistName}
                          </div>
                        </div>
                        <div className='widget-content-right'>
                          <ButtonGroup size='md'>
                            <Button
                              color='secondary'
                              onClick={() => playSong(value, 2)}
                              className='play-song-btn'
                            >
                              <i className='pe-7s-play'> </i>
                            </Button>
                            <Button
                              color='secondary'
                              onClick={() => selectSong(value, 2)}
                            >
                              {Strings('select')}
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                    </div>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </TabPane>

            <TabPane tabId='3'>
              {showOriginalSongForm && (
                <Fragment>
                  <Row>
                    <FormGroup tag={Col} md={12}>
                      <Label for="osso">{Strings('song_name')}</Label>
                      <Input
                        type="text"
                        name="osso"
                        id="osso"
                        innerRef={register}
                      />
                      {errors.osso && (
                        <p className="error-validation text-left">
                          {errors.osso.message}
                        </p>
                      )}
                    </FormGroup>
                  </Row>
                  <Row>
                    <FormGroup tag={Col} md={6}>
                      <Label for="osba">{Strings('band_name')}</Label>
                      <Input
                        type="text"
                        name="osba"
                        id="osba"
                        innerRef={register}
                      />
                      {errors.osba && (
                        <p className="error-validation text-left">
                          {errors.osba.message}
                        </p>
                      )}
                    </FormGroup>
                    <FormGroup tag={Col} md={6}>
                      <Label for="osge">{Strings('genre')}</Label>
                      <Input
                        type="select"
                        name="osge"
                        id="osge"
                        innerRef={register}
                      >
                        {genres && genres.map((item) => (
                          <option key={item.ID} value={item.ID}>{item.Name}</option>
                        ))}
                      </Input>
                      {errors.osge && (
                        <p className="error-validation text-left">
                          {errors.osge.message}
                        </p>
                      )}
                    </FormGroup>
                  </Row>
                  <Row className="mb-2">
                    <FormGroup tag={Col} md={6}>
                      <Label for="osfile">{Strings('song_file')}</Label>
                      <Input
                        type="file"
                        name="osfile"
                        id="osfile"
                        innerRef={register}
                      />
                      {errors.osfile && (
                        <p className="error-validation text-left">
                          {errors.osfile.message}
                        </p>
                      )}
                    </FormGroup>
                    <Col md={6}>
                      <p>{Strings('public_allowed_use')}</p>
                      <ButtonGroup size="lg" className="mb-2">
                        <Button
                          outline
                          color="primary"
                          active={ospau === 0}
                          onClick={() => setOspau(0)}
                        >
                          {Strings('no')}
                        </Button>
                        <Button
                          outline
                          color="primary"
                          active={ospau === 1}
                          onClick={() => setOspau(1)}
                        >
                          {Strings('yes')}
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>

                  <Row className='mb-3'>
                    <Col>
                      <div id="accordionOriginalSong" data-children=".item">
                        <div className="item">
                          <Button
                            className="m-0 p-0"
                            color="link"
                            onClick={() => toggleOsAccordion()}
                            aria-expanded={osAccordion}
                            aria-controls="accordionOriginalSong1"
                          >
                            {Strings('more_options')}
                          </Button>
                          <Collapse
                            isOpen={osAccordion}
                            data-parent="#accordionOriginalSong"
                            id="accordionOriginalSong1"
                          >
                            <Row className="mt-2">
                              <Col md={6}>
                                <Label for="oswe">{Strings('website')}</Label>
                                <Input
                                  type="url"
                                  name="oswe"
                                  id="oswe"
                                  innerRef={register}
                                />
                                {errors.oswe && (
                                  <p className="error-validation text-left">
                                    {errors.oswe.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={6}>
                                <Label for="ospe">{Strings('person')}</Label>
                                <Input
                                  type="text"
                                  name="ospe"
                                  id="ospe"
                                  innerRef={register}
                                />
                                {errors.ospe && (
                                  <p className="error-validation text-left">
                                    {errors.ospe.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-4">
                              <Col md={6}>
                                <Label for="osemail">{Strings('email')}</Label>
                                <Input
                                  type="email"
                                  name="osemail"
                                  id="osemail"
                                  innerRef={register}
                                />
                                {errors.osemail && (
                                  <p className="error-validation text-left">
                                    {errors.osemail.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={6}>
                                <Label for="ostel">{Strings('phone')}</Label>
                                <Input
                                  type="text"
                                  name="ostel"
                                  id="ostel"
                                  innerRef={register}
                                />
                                {errors.ostel && (
                                  <p className="error-validation text-left">
                                    {errors.ostel.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </Collapse>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className='mb-4'>
                    <Col>
                      <div id="accordionOriginalSongMusicLinks" data-children=".item">
                        <div className="item">
                          <Button
                            className="m-0 p-0"
                            color="link"
                            onClick={() => toggleOsMusicLinks()}
                            aria-expanded={osMusicLinks}
                            aria-controls="accordionOriginalSongMusicLinks1"
                          >
                            {Strings('music_links')}
                          </Button>
                          <Collapse
                            isOpen={osMusicLinks}
                            data-parent="#accordionOriginalSongMusicLinks"
                            id="accordionOriginalSongMusicLinks1"
                          >
                            <Row className="mt-2">
                              <Col md={4}>
                                <Label for="oslapple">{Strings('ml_apple_music')}</Label>
                                <Input
                                  type="url"
                                  name="oslapple"
                                  id="oslapple"
                                  innerRef={register}
                                />
                                {errors.oslapple && (
                                  <p className="error-validation text-left">
                                    {errors.oslapple.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="oslspotify">{Strings('ml_spotify')}</Label>
                                <Input
                                  type="url"
                                  name="oslspotify"
                                  id="oslspotify"
                                  innerRef={register}
                                />
                                {errors.oslspotify && (
                                  <p className="error-validation text-left">
                                    {errors.oslspotify.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="oslyoutube">{Strings('ml_youtube')}</Label>
                                <Input
                                  type="url"
                                  name="oslyoutube"
                                  id="oslyoutube"
                                  innerRef={register}
                                />
                                {errors.oslyoutube && (
                                  <p className="error-validation text-left">
                                    {errors.oslyoutube.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-4">
                              <Col md={4}>
                                <Label for="oslyoutubemusic">{Strings('ml_youtube_music')}</Label>
                                <Input
                                  type="url"
                                  name="oslyoutubemusic"
                                  id="oslyoutubemusic"
                                  innerRef={register}
                                />
                                {errors.oslyoutubemusic && (
                                  <p className="error-validation text-left">
                                    {errors.oslyoutubemusic.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="oslamazon">{Strings('ml_amazon_music')}</Label>
                                <Input
                                  type="url"
                                  name="oslamazon"
                                  id="oslamazon"
                                  innerRef={register}
                                />
                                {errors.oslamazon && (
                                  <p className="error-validation text-left">
                                    {errors.oslamazon.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="oslsoundcloud">{Strings('ml_soundcloud')}</Label>
                                <Input
                                  type="url"
                                  name="oslsoundcloud"
                                  id="oslsoundcloud"
                                  innerRef={register}
                                />
                                {errors.oslsoundcloud && (
                                  <p className="error-validation text-left">
                                    {errors.oslsoundcloud.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-4">
                              <Col md={4}>
                                <Label for="osldeezer">{Strings('ml_deezer')}</Label>
                                <Input
                                  type="url"
                                  name="osldeezer"
                                  id="osldeezer"
                                  innerRef={register}
                                />
                                {errors.osldeezer && (
                                  <p className="error-validation text-left">
                                    {errors.osldeezer.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="osltidal">{Strings('ml_tidal')}</Label>
                                <Input
                                  type="url"
                                  name="osltidal"
                                  id="osltidal"
                                  innerRef={register}
                                />
                                {errors.osltidal && (
                                  <p className="error-validation text-left">
                                    {errors.osltidal.message}
                                  </p>
                                )}
                              </Col>
                              <Col md={4}>
                                <Label for="oslcustom">{Strings('ml_custom_url')}</Label>
                                <Input
                                  type="url"
                                  name="oslcustom"
                                  id="oslcustom"
                                  innerRef={register}
                                />
                                {errors.oslcustom && (
                                  <p className="error-validation text-left">
                                    {errors.oslcustom.message}
                                  </p>
                                )}
                              </Col>
                            </Row>
                          </Collapse>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Button
                        color='primary'
                        onClick={handleSubmit(submitOriginalSong)}
                      >
                        {Strings('submit')}
                      </Button>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </TabPane>
          </TabContent>
        </Col>
      </Row>

      <ModalAppleMusicAlert
        modalOpen={modalAlertAppleMusic}
        toggleModal={toggleModalAlertAppleMusic}
      />

    </Fragment>
  );
}
